module.exports = __webpack_public_path__ + "static/media/profile-style-img2.01f837fe.png";